import './polyfills'

/**
 * Components
 */
export { Motion } from './components/Motion'
export { MotionVariant } from './components/MotionVariant'
export { MotionPresence } from './components/MotionPresence'

/**
 * Test utils
 */
export { disableMotion, enableMotion } from './utils'

/**
 * Types
 */
export type {
  AnimationDefinition,
  TargetAndTransition,
  TargetAndTransitionEnd,
} from './types'
